/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Manual
 *
 * 5 = Automatic
 */
export enum RequirementTransmType {
  Manual = 1,
  Automatic = 5,
}
